angular.module('data-ng-path-item').constant(
  'EventCategoryEnum',
  Enumeration('EventCategoryEnum', {
    TO_DO: {
      id: 'TO_DO',
      value: {
        label: 'To-Do',
        cssClass: 'to-do'
      }
    },
    RESOURCE: {
      id: 'RESOURCE',
      value: {
        label: 'Resource',
        cssClass: 'resource'
      }
    },
    DATE_MARKER: {
      id: 'DATE_MARKER',
      value: {
        label: 'Key Dates',
        cssClass: 'date-marker'
      }
    },
    TIP: {
      id: 'TIP',
      value: {
        label: 'Tips',
        cssClass: 'event-category--tip'
      }
    },
    POLL: {
      id: 'POLL',
      value: {
        label: 'Polls',
        cssClass: 'event-category--poll'
      }
    },
    PERSONAL_REMINDER: {
      id: 'PERSONAL_REMINDER',
      value: {
        label: 'Personal Reminders',
        cssClass: 'personal-reminder'
      }
    }
  })
);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/types/event_category_enum.js